<template>
  <div class="nav-card" @click="handleClick">
    <!-- 左侧图标 -->
    <span class="nav-card__icon">
      <svg width="15" height="15" viewBox="0 0 24 24" fill="none">
        <path d="M3 12h18M13 6l6 6-6 6" stroke="#0052D9" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </span>
    <!-- 文字 -->
    <span class="nav-card__label">{{ nav.label }}</span>
    <!-- 右侧箭头 -->
    <span class="nav-card__arrow">
      <svg width="13" height="13" viewBox="0 0 24 24" fill="none">
        <path d="M9 18l6-6-6-6" stroke="#0052D9" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </span>
  </div>
</template>

<script>
export default {
  name: 'NavigationCard',
  props: {
    nav: {
      type: Object,
      required: true,
      // { routeName: string, label: string, query?: Record<string, string>, params?: Record<string, string> }
    },
  },
  methods: {
    handleClick() {
      if (!this.nav.routeName) return;
      const targetQuery = this.nav.query || {};
      const targetParams = this.nav.params || {};
      const currentRoute = this.$route;
      // 判断是否与当前路由同名
      const isSameRoute = currentRoute.name === this.nav.routeName;

      if (isSameRoute) {
        // 同路由：加 _t 时间戳强制触发路由 watch，使页面重新加载数据
        this.$router.replace({
          name: this.nav.routeName,
          params: targetParams,
          query: { ...targetQuery, _t: Date.now() },
        }).catch(() => {});
      } else {
        this.$router.push({
          name: this.nav.routeName,
          params: targetParams,
          query: targetQuery,
        }).catch(() => {});
      }
    },
  },
};
</script>

<style scoped>
.nav-card {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 14px;
  background: #f0f5ff;
  border: 1.5px solid #c5d8ff;
  border-radius: 12px;
  cursor: pointer;
  transition: all 0.18s ease;
  width: 100%;
  box-sizing: border-box;
  user-select: none;
  box-shadow: 0 2px 8px rgba(0, 82, 217, 0.08);
}
.nav-card:hover {
  background: #e0ecff;
  border-color: #0052D9;
  transform: translateY(-1px);
  box-shadow: 0 3px 10px rgba(0, 82, 217, 0.15);
}
.nav-card:active {
  transform: translateY(0);
  box-shadow: none;
}
.nav-card__icon {
  display: flex;
  align-items: center;
  flex-shrink: 0;
}
.nav-card__label {
  font-size: 13px;
  font-weight: 500;
  color: #0052D9;
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.nav-card__arrow {
  display: flex;
  align-items: center;
  flex-shrink: 0;
  opacity: 0.7;
}
.nav-card:hover .nav-card__arrow {
  opacity: 1;
}
</style>
